export { default } from './Auth0Animation';



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/index.js